export { isBrowserUnsupported } from './unsupported-browsers';
